import ClientTableRow from './ClientTableRow';
import { FragmentType, useFragment } from '../../__generated__';
import { MyClientsSearchUserFragment } from './ClientFragments';

export type TransactionRowProps = {
  user: FragmentType<typeof MyClientsSearchUserFragment>;
};
const getType = (type: string): string => {
  if (!type) return '';
  return type.charAt(0).toUpperCase() + type.slice(1);
};

const ClientRow = (props: TransactionRowProps) => {
  const trx1 = useFragment(MyClientsSearchUserFragment, props.user);

  return (
    <ClientTableRow
      values={{
        name: trx1.name,
        phone: trx1.phone,
        type: getType(trx1.type),
        sender: trx1.senderRegisteredUser?.name || '',
        senderPhone: trx1.senderRegisteredUser?.phone || '',
      }}
      key={trx1.id}
    />
  );
};

export default ClientRow;
